import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';

type AddSignerRows = {
  label: string;
  id: vp.AddSignerId;
  require: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
};

export default function useAddSignerRows(): AddSignerRows[] {
  const { t } = useTranslation('translations', { keyPrefix: 'Hooks.UseAddSignerRows' });

  return [
    {
      label: t('fullName', { defaultValue: 'Full Name*' }),
      id: vp.AddSignerId.AuthorizedFullLegalName,
      require: true,
      preset: 'text',
    },
    {
      label: t('emailAddress', { defaultValue: 'Email Address*' }),
      id: vp.AddSignerId.AuthorizedEmailAddress,
      require: true,
      preset: 'text',
    },
    {
      label: t('title', { defaultValue: 'Title*' }),
      id: vp.AddSignerId.AuthorizedOccupation,
      require: true,
      preset: 'text',
    },
  ];
}
